module.exports = __webpack_public_path__ + "img/TIMES-CIRCLE.7f1b8464.svg";